import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ReportService } from '../..';

@Component({
    selector: 'app-res-rev-report',
    templateUrl: './res-rev-report.component.html',
    styleUrls: ['./res-rev-report.component.css'],
    standalone: false
})
export class ResRevReportComponent implements OnInit {


	// forms
	formLoading = false;

	// to hold the current search
	currentSearchForm: any;

	// data

	reservations: any[];
	reservationsTotalsByDay: any[];
	reservationsTotalsByMonth: any[];
	reservationsTotalsByYear: any[];

	// search defaults
	defaultStartDate: Date
	defaultEndDate: Date

	constructor(
		public messageService: MessageService,
		public reportService: ReportService) { }

	ngOnInit(): void {
		this.defaultStartDate = new Date();
		this.defaultStartDate = new Date(this.defaultStartDate.getFullYear(), this.defaultStartDate.getMonth(), 1);

		this.defaultEndDate = new Date();
		this.defaultEndDate = new Date(this.defaultStartDate.getFullYear(), this.defaultStartDate.getMonth() + 1, 0);
	}

	onSearchSubmit(searchForm: any) {
		// kill the old transformation
		// this.advertisedRateRows = [];

		// store the search
		this.currentSearchForm = searchForm;
		this.runReservationRevenueReport(searchForm);
	}

	runReservationRevenueReport(searchForm) {
		try {
			this.formLoading = true;
			this.reportService.reservationRevenueReport(searchForm)
				.subscribe(
					res => {
						console.log('runReservationRevenueReport SUCCESS: ' + JSON.stringify(res));

						this.reservations = res.data.resRevenues.resRev;
						this.reservationsTotalsByMonth = res.data.resRevenues.resRevTotalByMonth;
						this.reservationsTotalsByYear = res.data.resRevenues.resRevTotalByYear;

						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message, life: 3000 });
					},
					err => {
						console.log('runReservationRevenueReport FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Error', detail: err.message });
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error: runReservationRevenueReport' });
		}
	}

}
